import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c2ce30d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "boxEl",
  class: "nge-dst-box"
}
const _hoisted_2 = { class: "nge-dst-eyebrow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-dst-dot" }, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-dst-title" }
const _hoisted_5 = {
  key: 0,
  class: "nge-dst-stats"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-dst-stats-label" }, "Your work here", -1 /* HOISTED */))
const _hoisted_7 = {
  key: 0,
  class: "nge-dst-stat"
}
const _hoisted_8 = {
  key: 1,
  class: "nge-dst-stat"
}
const _hoisted_9 = {
  key: 1,
  class: "nge-dst-stats-first"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-dst-scan",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-dst-grid",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_13 = { class: "nge-dst-status" }
const _hoisted_14 = { class: "nge-dst-step" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-dst-dots",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i")
], -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.datasetTransition.current && $setup.phase)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["nge-dst", { 'nge-dst--zip': $setup.phase === 'zip', 'nge-dst--resumed': $setup.datasetTransition.resumed }]),
          style: _normalizeStyle({ '--dst-in': `-${$setup.elapsed}ms` }),
          "aria-live": "polite"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(_toDisplayString($setup.datasetTransition.current.eyebrow || 'Now entering'), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString($setup.datasetTransition.current.label), 1 /* TEXT */),
            _createVNode(_Transition, { name: "nge-dst-stats" }, {
              default: _withCtx(() => [
                ($setup.mine)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      ($setup.mine.edits || $setup.mine.completions || $setup.mine.helpRequests)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_6,
                            ($setup.mineAll || $setup.mine.edits)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                  _createElementVNode("b", null, _toDisplayString($setup.mine.edits.toLocaleString()), 1 /* TEXT */),
                                  _createTextVNode(" edit" + _toDisplayString($setup.mine.edits === 1 ? '' : 's'), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", {
                              class: _normalizeClass(["nge-dst-stat", { 'nge-dst-stat--cells': $setup.mine.completions }])
                            }, [
                              _createElementVNode("b", null, _toDisplayString($setup.mine.completions.toLocaleString()), 1 /* TEXT */),
                              _createTextVNode(" cell" + _toDisplayString($setup.mine.completions === 1 ? '' : 's') + " proofread", 1 /* TEXT */)
                            ], 2 /* CLASS */),
                            ($setup.mine.helpRequests)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createElementVNode("b", null, _toDisplayString($setup.mine.helpRequests.toLocaleString()), 1 /* TEXT */),
                                  _createTextVNode(" help request" + _toDisplayString($setup.mine.helpRequests === 1 ? '' : 's'), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "Your first visit here. Welcome, scientist!"))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-dst-thumb", { 'nge-dst-thumb--empty': !$setup.datasetTransition.current.thumbnail, 'nge-dst-thumb--contain': $setup.datasetTransition.current.contain }])
            }, [
              ($setup.datasetTransition.current.thumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.datasetTransition.current.thumbnail,
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_10))
                : _createCommentVNode("v-if", true),
              _hoisted_11,
              _hoisted_12
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString($setup.STEPS[Math.min($setup.stepIdx, $setup.STEPS.length - 1)]), 1 /* TEXT */),
              _hoisted_15
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-dst-bar", { 'nge-dst-bar--hold': $setup.datasetTransition.current.hold }]),
              "aria-hidden": "true"
            }, _hoisted_17, 2 /* CLASS */)
          ], 512 /* NEED_PATCH */)
        ], 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true)
  ]))
}